﻿export function detectDevice() {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) {
    document.body.classList.add("is-ios");
    window.isIOS = true;
  }
}